<template>
<div>
    <header>
        <div class="inr">
            <span class="prev">
                <a @click="$router.go(-1)">
                    <img src="@/assets/image/icon-prev.png" alt="뒤로가기">
                </a>
            </span>
            <h1>회원 탈퇴</h1>
        </div>
    </header>
    <Footer />
    <main id="sub">
        <div class="inr">
            <div class="input-wrap">
                <label>탈퇴 유형</label>
                <div class="input-wrap" :class="{on : selectError}">
                    <select v-model="leaveType_selected" @change="leaveTypeSelect()">
                        <option value="" disabled selected hidden>탈퇴 유형 선택</option>
                        <option v-for="(option, idx) in leaveType_options" :value="option.value" :key="idx">
                            {{option.text}}
                        </option>
                    </select>
                    <small class="input-status error">탈퇴 유형을 선택해주세요</small>
                </div>
            </div>
            <div class="input-wrap" v-show="inputShow" :class="{on : inputError}">
                <input type="text" placeholder="직접 입력" v-model="inputText">
                <small class="input-status error">탈퇴 사유를 입력해주세요.</small>
            </div>
            <div class="input-wrap" :class="{on : emailError.flag}">
                <label>이메일 확인</label>
                <input type="text" placeholder="가입하신 이메일을 입력해주세요." v-model="email">
                <small class="input-status error">{{emailError.msg}}</small>
            </div>
            <ul class="leave_info_text">
                <li>• 현재 사용중인 계정은 회원 탈퇴 후, 재가입 및 복구가 불가합니다.</li>
                <li>• 탈퇴 후 회원님의 정보는 "숲속휴식" 개인정보처리방침에 따라 관리됩니다.</li>
                <li>• 회원님의 공용공간 서비스 예약 이력은 모두 취소됩니다.</li>
                <li>• 포인트는 탈퇴 시, 자동으로 소멸됩니다.</li>
            </ul>
            <ul class="check-lists" style="margin-top:10px; margin-bottom: 20px;">
                <li class="check-list">
                    <p class="custom-checkbox">
                        <input type="checkbox" id="checkAll" v-model="checked" @click="checked=!checked">
                        <label for="checkAll">
                            <span class="label-txt">
                                <small :style="{color : checked ? 'black' : '#888'}" style="padding-top:4px;">주의사항을 모두 확인하였습니다.</small>
                            </span>
                        </label>
                    </p>
                </li>
            </ul>
            <div class="btn-wrap">
                <div class="btn" type="button" :class="{disable : !checked}" @click="saveLeaveUser()">회원 탈퇴</div>
            </div>
        </div>
    </main>
</div>
</template>

<script>
import Footer from "@/components/common/Footer";

export default {
    components: {
        Footer
    },
    data() {
        return {
            user_pk: this.$store.state.userInfo.pk,
            user_email: this.$store.state.userInfo.email,

            email: "",

            leaveType_selected: "",
            leaveType_options: [{
                    value: "A",
                    text: "계약기간이 만료되었어요"
                },
                {
                    value: "B",
                    text: "중도 퇴실하였어요"
                },
                {
                    value: "C",
                    text: "비매너 입주자가 존재해요"
                },
                {
                    value: "D",
                    text: "대체할만한 공간을 찾았어요"
                },
                {
                    value: "E",
                    text: "쿠폰 / 포인트 등 혜택이 적어요"
                },
                {
                    value: "Z",
                    text: "기타"
                }
            ],

            inputShow: false,
            inputText: "",
            checked: false,

            selectError: false,
            inputError: false,
            emailError: {
                flag: false,
                msg: "가입하신 이메일을 입력해주세요."
            }
        };
    },
    methods: {
        leaveTypeSelect() {
            // 탈퇴유형이 기타(Z)인 경우 input창 활성화
            this.inputShow = this.leaveType_selected === "Z";
        },
        saveLeaveUser() {
            if (!this.checked) {
                return false;
            }

            this.selectError = this.leaveType_selected === "";
            this.inputError = this.inputText === "" && this.leaveType_selected === "Z";

            if (this.email === "") {
                this.emailError.flag = true;
                this.emailError.msg = "가입하신 이메일을 입력해주세요.";
                return;
            } else {
                this.emailError.flag = false;
            }

            if (this.email !== this.user_email) {
                this.emailError.flag = true;
                this.emailError.msg = "가입하신 이메일과 일치하지 않습니다.";
            } else {
                this.emailError.flag = false;
            }

            if (!this.selectError && !this.inputError && !this.emailError.flag) {
                if (confirm("숲속휴식을 정말 탈퇴하시겠습니까?")) {
                    this.axios.post(`/user/leave/${this.user_pk}`, {
                        leave_type: this.leaveType_selected,
                        leave_type_text: this.leaveType_options.find(option => option.value === this.leaveType_selected).text,
                        leave_message: this.leaveType_selected === "Z" ? this.inputText : "",
                    }).then(() => {
                        alert("탈퇴가 완료되었습니다.\n그동안 숲속 휴식을 사랑해 주셔서 감사합니다.")

                        this.$store.commit("DEL_TOKEN");
                        this.$store.commit("DEL_USERINFO");

                        this.$router.push({
                            path: "/"
                        });
                    }).catch(err => {
                        console.log(err);
                    });
                }
            }
        }
    }
};
</script>

<style scoped>
.leave_info_text {
    margin-top: 20px;
    padding: 15px;
    background-color: rgb(242, 243, 247);
    font-size: 13px;
    color: rgb(114, 117, 133);
    line-height: 24px;
    box-sizing: border-box;
}
</style>
